import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextDisplayMode = /** @class */ (function (_super) {
    __extends(TextDisplayMode, _super);
    function TextDisplayMode() {
        var _this = _super.call(this) || this;
        console.warn('[TextDisplayMode] not implemented');
        return _this;
    }
    TextDisplayMode.classInitializer = null;
    TextDisplayMode.classSymbols = null;
    TextDisplayMode.instanceSymbols = null;
    TextDisplayMode.LCD = 'lcd';
    TextDisplayMode.CRT = 'crt';
    TextDisplayMode.DEFAULT = 'default';
    return TextDisplayMode;
}(ASObject));
export { TextDisplayMode };
